<div class="layout-sidebar">
    <a [routerLink]="['/']" class="logo">
        <div class="logo-image pre-app-name">
            <img [src]="layoutService.iconLogo()" class="w-full"/>
        </div>
        <!--    Ani se neptejte, prostě nějaký ojeb kolem té šablony pro přepnutí loga    -->
        <div class="horizontal-logo app-name" style="width:9rem;">
            <img [src]="layoutService.horizontalLogo()" class="w-full"/>
        </div>
    </a>
    <div class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
